<template>
  <div
    class="image-wrapper"
    :class="isLoaded ? 'loaded' : 'loading'"
    :style="computedImageWrapperStyle"
  >
    <picture class="placeholder">
      <img :src="placeholder" :alt="caption" />
    </picture>

    <picture>
      <slot>
        <source :srcset="image" />
      </slot>
      <img
        :src="image"
        :alt="caption"
        class="full"
        loading="lazy"
        @load="imageLoaded"
      />
    </picture>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

@Component
export default class ProgressiveImage extends Vue {
  @Prop({ type: String, default: '' })
  readonly image!: string;

  @Prop({ type: String, default: '' })
  readonly placeholder!: string;

  @Prop({ type: String, default: '' })
  readonly caption!: string;

  @Prop({ type: String, default: NebraskaColors.backgroundTertiary })
  readonly background!: string;

  public isLoaded = false;

  @Watch('placeholder')
  loadNewImage() {
    this.isLoaded = false;
  }

  @Emit()
  imageLoaded() {
    this.isLoaded = true;
  }

  get computedImageWrapperStyle() {
    return {
      background: this.background
    };
  }
}
</script>

<style lang="less" scoped>
.image-wrapper,
picture,
img {
  border-radius: inherit;
  display: block;
  font-size: 0;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

img {
  object-fit: cover;
}

.image-wrapper {
  backface-visibility: hidden;
  display: block;
  max-width: 100%;
  max-height: 100%;
  overflow: hidden;
  position: relative;
  transform: translate3d(0, 0, 0);
}
.placeholder,
.loading .full {
  filter: blur(30px);
  transform: scale(0.97);
}

.placeholder {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
}

.full {
  opacity: 0;
  position: relative;
  transition: opacity 200ms, all 1000ms cubic-bezier(0, 0, 0.2, 1);
  z-index: 1;

  .loaded & {
    filter: blur(0);
    opacity: 1;
  }
}
</style>
